import router from '@/router';
import store from '@/store/index'
import axios from "axios";
import Vue from 'vue';
let tipsShow = true
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 300000,
  withCredentials: true  // 如果采用token方式传递用户信息，请将本行代码屏蔽
});

service.interceptors.request.use(
  config => {
    config.headers['accessToken'] = localStorage.getItem('yinyi_token') || ''
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // 处理其他API的响应格式
      if (response.data.errorCode == null) {
        tipsShow = true
        return response.data;
      }else if (response.data.errorCode === "000403") {
        if(tipsShow) {
          Vue.prototype.$message.error('登录已过时限,请重新登陆')
          tipsShow = false
        }
        store.commit("CLEAR_VUEX")
        router.push({
          path: '/'
        });
      } else {
        if(tipsShow) {
          Vue.prototype.$message.error(response.data.errorMessage)
          tipsShow = false
        }
        return response.data;
      }
    } else {
      store.commit("CLEAR_VUEX")
      router.push({
        path: '/'
      });
    }
  },
  error => {
    if (error.response && error.response.status == '000403') {
      if(tipsShow) {
        Vue.prototype.$message.error('登录已过时限,请重新登陆')
        tipsShow = false
      }
      store.commit("CLEAR_VUEX")
      router.push({
        path: '/'
      });
      return Promise.reject(error);
    } else {
      Vue.prototype.$message.error('服务器异常')
      return Promise.reject(error);
    }
  }
);

export default service;
